<template>
  <!-- MENÚ DE LA PREVISUALIZACIÓN DE UN EVENTO -->
  <v-row justify="center" align="center" class="bottom-navbar primary white--text">
    <v-btn @click="edit()" active-class="accent" large color="accent" class="mr-3 black--text">
      Editar
    </v-btn>
    <v-btn @click.stop="save()" large color="accent" class="black--text">
      Guardar
    </v-btn>
  </v-row>
</template>
<script>
import { mapMutations } from 'vuex'
  export default {
    data () {
      return {

      }
    },
    methods:{
      ...mapMutations('user',['leavingEventPreview']),
      ...mapMutations('event',['saveEvent']),
      ...mapMutations('notifications',['show']),
      edit(){
        this.$router.push('/dashboard/nuevo-evento');
        this.leavingEventPreview()
      },
      save(){
        this.saveEvent();
        this.show({ text:'¡Evento guardado con éxito!'});
        this.$router.push('/dashboard/eventos');
      }
    }
  }
</script>
<style scoped>
.bottom-navbar{
  position: fixed;
  bottom: -1px;
  width: 100vw;
  height: 70px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

@media (max-width: 1264px){
  .bottom-navbar{
    width: 105vw;
  }
}

@media (min-width: 1264px) and (max-width: 1903px)  {
  .bottom-navbar{
    height: 12vh;
  }
}

@media (min-width: 1904px) {
  .bottom-navbar{
    height: 8vh;
  }
}
</style>

